import React, { useState } from "react"
import GroupDates from "./GroupDates"
import ServiceGuestCreation from "./ServiceGuestCreation"
import ServiceGuestLogin from "./ServiceGuestLogin"
import { formatTextWithBreaks } from "../../utils/services/service-content-formatter"
import { LoginFormProvider } from "../auth/login-form/context"
import { RegisterFormProvider } from "../auth/register-form/context"
import { SvgCheckCircle } from "../icons"

interface Props {
  service: any
  coachPublicProfileData: any
  cardFieldErrors: {
    cardName: boolean
    cardNumber: boolean
    cardExpiry: boolean
    cardCvv: boolean
  }
  setCardFieldErrors: React.Dispatch<
    React.SetStateAction<{
      cardName: boolean
      cardNumber: boolean
      cardExpiry: boolean
      cardCvv: boolean
    }>
  >
}

const StandardService: React.FC<Props> = ({
  service,
  coachPublicProfileData,
  cardFieldErrors,
  setCardFieldErrors,
}) => {
  const [emailExists, setEmailExists] = useState(false)
  const [guestEmail, setGuestEmail] = useState("")

  return (
    <div className="flex flex-col md:flex-row gap-4 mt-8">
      {" "}
      <div className="flex-1">
        {service.is_group_service && (
          <GroupDates
            coachPublicProfileData={coachPublicProfileData}
            service={service}
          />
        )}
        {service?.service_details?.details?.description1 && (
          <div className="mb-8">
            {formatTextWithBreaks(
              service?.service_details?.details?.description1
            )}
          </div>
        )}
        {service?.service_details?.details?.features?.feature1 && (
          <div className="mb-8 mr-auto flex flex-col gap-4 text-base">
            <div className="flex items-center gap-[12px]">
              <SvgCheckCircle
                fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
              />
              {service?.service_details?.details.features.feature1}
            </div>
            {service?.service_details?.details?.features?.feature2 && (
              <div className="flex items-center gap-[12px]">
                <SvgCheckCircle
                  fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
                />
                {service?.service_details?.details.features.feature2}
              </div>
            )}
            {service?.service_details?.details?.features?.feature3 && (
              <div className="flex items-center gap-[12px]">
                <SvgCheckCircle
                  fill={`${coachPublicProfileData?.profile_information?.profileColor}`}
                />
                {service?.service_details?.details.features.feature3}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="md:border-l md:border-gray-300 flex-1">
        {!emailExists ? (
          <>
            {" "}
            <RegisterFormProvider
              defaultEmail=""
              defaultAccountType={null}
              defaultFirstName=""
              defaultLastName=""
              defaultPassword=""
              defaultPhone=""
              onSuccess={() => true}
            >
              <ServiceGuestCreation
                coachPublicProfileData={coachPublicProfileData}
                service={service}
                setEmailExists={setEmailExists}
                setGuestEmail={setGuestEmail}
                cardFieldErrors={cardFieldErrors}
                setCardFieldErrors={setCardFieldErrors}
              />
            </RegisterFormProvider>
          </>
        ) : (
          <>
            <LoginFormProvider defaultEmail="" onSuccess={() => true}>
              <ServiceGuestLogin
                coachPublicProfileData={coachPublicProfileData}
                service={service}
                guestEmail={guestEmail}
                sentVerification={setEmailExists}
                cardFieldErrors={cardFieldErrors}
                setCardFieldErrors={setCardFieldErrors}
              />
            </LoginFormProvider>
          </>
        )}
      </div>
    </div>
  )
}

export default StandardService
